import { ArrowsPointingInIcon, ArrowsPointingOutIcon } from "@heroicons/react/24/solid";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../stores/store";
import PlayerQualityLevel from "./PlayerQualityLevel";
import { playerActions } from "./playerSlice";
import { PlayerVolume } from "./PlayerVolume";
import { usePlayerPage } from "../../hooks/usePlayerPage.tsx";
import PlayerChangeChannelListPopup from "../popups/PlayerChangeChannelListPopup.tsx";
import { AppMainStateContext } from "../../contexts/AppMainStateContext.tsx";

export const PlayerUITopBar = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { hlsQualityLevels, toggleFullscreen } = usePlayerPage();
    const channels = useAppSelector(store => store.playerUI.channels);
    const isMenuUIVisible = useAppSelector(state => state.playerUI.isMenuUIVisible);
    const isMuted = useAppSelector(state => state.player.muted);
    const volumeValue = useAppSelector(state => state.player.volume);
    const qualityLevel = useAppSelector(state => state.player.qualityLevel);
    const { isIOS } = useContext(AppMainStateContext);

    const [isVolumeControlVisible, setIsVolumeControlVisible] = useState(false);
    const [isQualityControlVisible, setIsQualityControlVisible] = useState(false);
    const [isChannelListPopupOpen, setIsChannelListPopupOpen] = useState(false);
    const isFullScreenMode = useAppSelector(store => store.playerUI.isFullscreen);
    const markerBtn = useRef<HTMLButtonElement>(null);
    const playerChannelListPopupRef = useRef<{ closePopup: () => void }>(null);
    const volumeControlPopupRef = useRef<{ closePopup: () => void }>(null);
    const qualityControlPopupRef = useRef<{ closePopup: () => void }>(null);

    if (!isMenuUIVisible) {
        setTimeout(() => {
            if (isVolumeControlVisible) setIsVolumeControlVisible(false);
            if (isQualityControlVisible) setIsQualityControlVisible(false);
            if (isChannelListPopupOpen) setIsChannelListPopupOpen(false);
        }, 300)
    }

    const closeChannelListPopup = () => {
        if (playerChannelListPopupRef.current)
            playerChannelListPopupRef.current.closePopup();
    }

    const closeVolumeControlPopup = () => {
        if (volumeControlPopupRef.current)
            volumeControlPopupRef.current.closePopup();
    }

    const closeQualityControlPopup = () => {
        if (qualityControlPopupRef.current)
            qualityControlPopupRef.current.closePopup();
    }

    const handleClickToggleFullScreen = async () => {
        closeQualityControlPopup();
        closeChannelListPopup();
        closeVolumeControlPopup();
        await toggleFullscreen();
    }

    const handlePlayerVolumeButtonClick = (isOpen: boolean) => {
        closeQualityControlPopup();
        closeChannelListPopup();        // setIsChannelListPopupOpen(false);
        setIsVolumeControlVisible(isOpen);
    }

    const handlePlayerQualityLevelButtonClick = (isOpen: boolean) => {
        setIsQualityControlVisible(isOpen);
        closeChannelListPopup();
        closeVolumeControlPopup();
    }

    const handlePlayerChannelListPopupButtonClick = (isOpen: boolean) => {
        setIsChannelListPopupOpen(isOpen);
        closeQualityControlPopup();
        closeVolumeControlPopup();
    }

    const handleBackButtonClick = () => {
        navigate(-1);
    }

    return (
        <div
            className={`${isIOS && "hidden"} absolute top-0 bg-linear-to-b from-neutral-900 to-transparent right-0 left-0 h-12`}
        >
            <div className={"flex justify-between py-2 mx-2 text-white"}>
                <div className={"flex items-center"}>
                    <button onClick={() => handleBackButtonClick()}>
                        <ChevronLeftIcon className={"w-7 h-7 text-white"} />
                    </button>
                    <PlayerChangeChannelListPopup ref={playerChannelListPopupRef} isOpen={isChannelListPopupOpen}
                        setIsOpen={handlePlayerChannelListPopupButtonClick}
                        channels={channels} />
                </div>
                {/*marker btn*/}
                <button id="playerUITopBarMarkerBtn" ref={markerBtn}></button>
                <div className={`${isIOS ? "hidden" : "flex"} space-x-2`}>
                    <PlayerQualityLevel
                        ref={qualityControlPopupRef}
                        isOpen={isQualityControlVisible}
                        onChangeSelectLevel={(qualityLevel) => dispatch(playerActions.setQualityLevel(qualityLevel))}
                        qualityLevels={hlsQualityLevels}
                        selectedLevel={qualityLevel}
                        setIsOpen={handlePlayerQualityLevelButtonClick} />
                    <PlayerVolume
                        ref={volumeControlPopupRef}
                        isOpen={isVolumeControlVisible}
                        isMuted={isMuted}
                        value={volumeValue}
                        setIsOpen={handlePlayerVolumeButtonClick} />

                    <button
                        onClick={handleClickToggleFullScreen}
                    >
                        {isFullScreenMode ?
                            <ArrowsPointingInIcon
                                className={"w-7 h-7 focus:outline-hidden"}
                            />
                            :
                            <ArrowsPointingOutIcon
                                className={"w-7 h-7 focus:outline-hidden"}
                            />
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}
